var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesIcons2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Services Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2721 11.2751C11.1753 11.37 11.0986 11.4833 11.0465 11.6084C10.9944 11.7335 10.9679 11.8678 10.9687 12.0033C10.961 12.2093 11.0165 12.4128 11.1277 12.5864C11.2389 12.76 11.4004 12.8955 11.5908 12.9748C11.7811 13.054 11.9911 13.0731 12.1926 13.0296C12.3942 12.9862 12.5776 12.8821 12.7184 12.7315C12.8152 12.6366 12.8919 12.5233 12.944 12.3982C12.9961 12.2731 13.0226 12.1388 13.0218 12.0033C13.0226 11.8678 12.9961 11.7335 12.944 11.6084C12.8919 11.4833 12.8152 11.37 12.7184 11.2751C12.6247 11.1795 12.513 11.1035 12.3897 11.0514C12.2665 10.9993 12.1341 10.9723 12.0003 10.9717C11.8648 10.9709 11.7305 10.9974 11.6054 11.0495C11.4803 11.1016 11.367 11.1783 11.2721 11.2751Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.73459 12.0032C9.7371 11.6199 9.83814 11.2438 10.0279 10.9109L9.13791 10.0107C8.73338 10.5945 8.5166 11.2878 8.5166 11.9981C8.5166 12.7083 8.73338 13.4017 9.13791 13.9855L10.0279 13.0955C9.8406 12.7615 9.73974 12.386 9.73459 12.0032Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9622 10.9109C14.1519 11.2438 14.253 11.6199 14.2555 12.0032C14.2503 12.386 14.1495 12.7615 13.9622 13.0955L14.8522 13.9855C15.2567 13.4017 15.4735 12.7083 15.4735 11.9981C15.4735 11.2878 15.2567 10.5945 14.8522 10.0107L13.9622 10.9109Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.6541 6.33989C16.3448 5.03215 14.6227 4.21874 12.7811 4.03819C10.9394 3.85763 9.09213 4.3211 7.55384 5.34966C6.01554 6.37822 4.88135 7.90827 4.34452 9.67918C3.80769 11.4501 3.90139 13.3523 4.60965 15.0619C5.3179 16.7715 6.59692 18.1827 8.22885 19.0551C9.86077 19.9275 11.7447 20.2072 13.5597 19.8466C15.3747 19.4859 17.0085 18.5072 18.1829 17.0771C19.3573 15.6471 19.9996 13.8541 20.0005 12.0036C20.0032 10.9513 19.7972 9.90895 19.3944 8.93679C18.9917 7.96463 18.4001 7.08197 17.6541 6.33989ZM15.338 15.3411C14.6792 16.0113 13.8354 16.4696 12.9145 16.6576C11.9937 16.8455 11.0378 16.7545 10.169 16.3961C9.30023 16.0377 8.55807 15.4283 8.03755 14.6458C7.51703 13.8633 7.24182 12.9434 7.24704 12.0036C7.24971 10.7518 7.74818 9.552 8.63336 8.66682C9.51854 7.78164 10.7183 7.28317 11.9701 7.2805C12.9099 7.27528 13.8299 7.55051 14.6124 8.07103C15.3948 8.59156 16.0043 9.33368 16.3626 10.2025C16.721 11.0712 16.812 12.0272 16.6241 12.948C16.4362 13.8688 15.9778 14.7126 15.3077 15.3715L15.338 15.3411Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.0824 10.0412L13.9825 9.14113C13.4004 8.73247 12.7064 8.51318 11.9952 8.51318C11.2839 8.51318 10.5899 8.73247 10.0078 9.14113L10.908 10.0412C11.2438 9.86661 11.6167 9.77543 11.9952 9.77543C12.3737 9.77543 12.7466 9.86661 13.0824 10.0412Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.0002 14.2186C11.617 14.2161 11.2409 14.1151 10.908 13.9253L10.0078 14.8153C10.5916 15.2198 11.285 15.4366 11.9952 15.4366C12.7054 15.4366 13.3987 15.2198 13.9825 14.8153L13.0925 13.9253C12.7586 14.1126 12.383 14.2134 12.0002 14.2186Z",
    fill: "#696969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcons2);
export default __webpack_public_path__ + "static/media/Services Icons (2).015b1a231ae9ff3500daad2ed5fee712.svg";
export { ForwardRef as ReactComponent };